import { peso } from '../../lib/format.js';
import { feeLadder } from './lib.js';
import './setup.css';

/**
 * Distance → fee as a stepped bar ladder: one bar per whole km up to the delivery limit. The base
 * fee is the Ink part of each bar, every km past the included distance stacks on in Cart Blue, and
 * each bar carries its fee. Used on Zones & fees (big) and in Settings' live preview (compact).
 */
export function FeeLadder({ delivery, compact = false }: { delivery: Record<string, unknown> | null | undefined; compact?: boolean }) {
  const steps = feeLadder(delivery);
  if (!steps.length) return <div className="dv-quiet">Fix the numbers to see the fees</div>;
  const top = Math.max(1, ...steps.map((s) => s.feeCentavos));
  const every = steps.length > 16 ? 3 : steps.length > 10 ? 2 : 1;
  const label = `Delivery fee by distance: ${steps.map((s) => `${s.km} km ${peso(s.feeCentavos)}`).join(', ')}`;
  return (
    <div className={compact ? 'st-ladder compact' : 'st-ladder'} role="img" aria-label={label}>
      {steps.map((s, j) => {
        const show = j % every === 0 || j === steps.length - 1;
        const baseH = ((s.feeCentavos - s.extraCentavos) / top) * 100;
        const extraH = (s.extraCentavos / top) * 100;
        return (
          <div key={s.km} className={s.included ? 'step inc' : 'step'} style={{ ['--j' as string]: j }} title={`${s.km} km · ${peso(s.feeCentavos)}`}>
            <span className="fee" aria-hidden="true">
              {show ? peso(s.feeCentavos) : ''}
            </span>
            <span className="st-col" aria-hidden="true">
              <i className="bs" style={{ height: `${baseH}%` }} />
              {s.extraCentavos ? <i className="ex" style={{ bottom: `${baseH}%`, height: `${extraH}%` }} /> : null}
            </span>
            <span className="km" aria-hidden="true">
              {show ? `${s.km}` : ''}
            </span>
          </div>
        );
      })}
    </div>
  );
}
